import NavigationBar from "../comps/NavigationBar/NavigationBar";
import Footer from "../comps/Footer/Footer";

export default function Attributions() {
  return (
    <div className="general-background">
      <NavigationBar />
      <div className="main-container" style={{ textAlign: "center" }}>
        <script type="text/javascript"></script>
        <iframe
          style={{ width: "80%", height: "100vh", backgroundColor: "#ffffff" }}
          title="Team attribution form"
          id="igem-attribution-form"
          src="https://attributions.igem.org?team=sysu-software&year=2023"
        ></iframe>
      </div>
      <Footer />
    </div>
  );
}
